import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class MilkPickupHaulerRef {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string
}
